import React, { FC } from 'react';

import { theme } from '../../../../global';
import BasicTimer from '../Basic';
import { BasicCommandType } from '../config';

const TimerBlueCommand: FC<BasicCommandType> = (props) => (
  <BasicTimer
    {...props}
    $inactive_color={theme.colors.inactive_blue}
    $active_color={theme.colors.active_blue}
  />
);

export default TimerBlueCommand;
